// import HeaderTutorial from "./HeaderTutorial.vue";
import HeaderTerms from "./HeaderTerms.vue";
import HeaderAbout from "./HeaderAbout.vue";
import HeaderFeedback from "./HeaderFeedback.vue";
// import HeaderNews from "./HeaderNews.vue";
import { defineAsyncComponent } from "vue";
const HeaderNews = defineAsyncComponent(() => import("./HeaderNews.vue"));
const HeaderTutorial = defineAsyncComponent(() => import("./HeaderTutorial.vue"));
export default {
  name: "HeaderView",
  components: {
    HeaderTutorial,
    HeaderTerms,
    HeaderAbout,
    HeaderFeedback,
    HeaderNews
  }
};